import { useState, useContext, useEffect } from "react";
import { RiCloseFill } from "react-icons/ri"
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import ApiContext from "src/provider/API/call-service";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { AbsoluteContainer, AppText, Button, FlexColumn, FlexRow, Form, FormGroup, FormGroupWithIcon, SidePopupContainer } from "src/style"
import { UserTypes, QoreStaffTypes, OptionType, UpdateUserProps } from "src/model";
import helpers from "src/utils/helpers";
import { FiChevronDown } from "react-icons/fi";
import { useTranslation } from "react-i18next";


export const CreateUser: React.FC<any> = ({ getUsers, close, isEdit }) => {
    const { notifier } = useContext(VisibilityContext)
    const { API } = useContext(ApiContext)
    const { info: { userType, editingUser,role,institutionData } } = useContext(AppInfoContext)
    const [user, setUser] = useState({ userType, role });

    const [input, setInput] = useState({
        firstName: isEdit ? editingUser?.firstName : '',
        lastName: isEdit ? editingUser?.lastName : '',
        email: isEdit ? editingUser?.email : '',
        phoneNumber: isEdit ? editingUser?.phoneNumber : '',
        username: isEdit ? editingUser?.username : '',
        isAdminRole: isEdit ? editingUser?.isAdminRole : false,
        role: isEdit ? editingUser?.role : '',
        ibInstitutionCode: isEdit ? editingUser?.ibInstitutionCode : ''
    })
    const [allInstitutions, setAllInstitutions] = useState<any[]>([])

    console.log("userType", userType);

      const institutions: OptionType[] = allInstitutions?.map(
          (institution: any) => ({ label: institution.name, value: institution.id })
        );

    const { t } = useTranslation()
    let adminUsers = [UserTypes.ADMIN, UserTypes.USER];

    async function handleFetchInstitution() {
        const response = await API.getAllInstitutions();
        if (response?.length)
            setAllInstitutions(helpers.sortItemsWIthString(response, "name", "asc"));
    }

    useEffect(() => {
        if (!adminUsers.includes(user.userType)) {
            void handleFetchInstitution();
        }

    }, [role]);

    console.log("input", editingUser);


    const handleInput = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => setInput({ ...input, [e.target.name]: e.target.value })

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (!helpers.validatePhoneNoAll(input.phoneNumber)) return notifier.show(t('users.createUser.phoneNumber.validation'), "validation Response")

        const payload = {
            ...input,
            ...(userType === UserTypes.SUPER_ADMIN && input.ibInstitutionCode
                ? { ibInstitutionCode: Number(input.ibInstitutionCode) }
                : {ibInstitutionCode: institutionData?.id}),
        }

        let response

        if (userType === UserTypes.SUPER_ADMIN) {
            // payload.role = 'SA'
            response = await API.createSuperAdmin(payload)
        }
        else {
            // payload.role = (input.isAdminRole ? 'Admin' : 'User')
            response = await API.createInstitutionUser(payload)
        }


        if (response) {
            if (getUsers) getUsers()
        }
        close()
    }


    async function handleEditSubmit(e:React.FormEvent<HTMLButtonElement | HTMLFormElement>){
        e.preventDefault()

        const payload: UpdateUserProps ={
            ibInstitutionCode: Number(input.ibInstitutionCode),
            firstName: input.firstName,
            lastName: input.lastName,
            oldEmail: editingUser?.email,
            newEmail: input.email,
            phoneNumber: input.phoneNumber,
            username: input.username,
            role: input.role
        }
        
        let response
        if (userType === UserTypes.SUPER_ADMIN) {
            response = await API.updateUserDetails(payload)
        }

         if (response) {
            if (getUsers) getUsers()
        }
        close()
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="new-ads-container"
                justifyContent="flex-start"
                alignItems="flex-start"
            >
                <AbsoluteContainer top='1.5' right='1.5'>
                    <Button
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{ fontSize: '2.3rem' }} />
                    </Button>
                </AbsoluteContainer>
                <AppText color='#101828' textSize="1.8" fontWeight="700" fontFamily="Gilmer-Bold">
                    {isEdit ? t('users.createUser.editTitle') : t('users.createUser.title')}
                </AppText>
                <Form onSubmit={isEdit ? handleEditSubmit : handleSubmit} topMargin='2'>
                    <FormGroup>
                        <label>{t('users.createUser.firstName.label')}</label>
                        <input
                            placeholder={t('users.createUser.firstName.placeholder')}
                            name='firstName'
                            value={input.firstName}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>
                    <FormGroup>
                        <label>{t('users.createUser.lastName.label')}</label>
                        <input
                            placeholder={t('users.createUser.lastName.placeholder')}
                            name='lastName'
                            value={input.lastName}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>
                    <FormGroup>
                        <label>{t('users.createUser.username.label')}</label>
                        <input
                            placeholder={t('users.createUser.username.placeholder')}
                            name='username'
                            value={input.username}
                            onChange={handleInput}
                            required
                            disabled={isEdit}
                        />
                    </FormGroup>
                    <FormGroupWithIcon>
                        <label>{t('users.createUser.role.label')}</label>
                        <div className="input-with-icon">
                            <select
                                name='role'
                                value={input.role}
                                onChange={handleInput}
                                required
                            >
                                <option>{t('users.createUser.role.placeholder')}</option>
                                {roles?.[userType as UserTypes].map((role) => (<option key={role.value} value={role.value}>{t(`users.createUser.role.options.${role.key}`)}</option>))}
                            </select>
                            <FiChevronDown className="input-with-icon-tag" />
                        </div>
                    </FormGroupWithIcon>

                    {input.role === QoreStaffTypes.INSTITUTION_ADMIN && (userType === UserTypes.SUPER_ADMIN)  && (
                        <FormGroupWithIcon>
                            <label>{t('users.createUser.institution.label')}</label>
                            <div className="input-with-icon">
                                <select
                                    name='ibInstitutionCode'
                                    value={input.ibInstitutionCode}
                                    onChange={handleInput}
                                    required
                                >
                                    <option>{t('users.createUser.institution.placeholder')}</option>
                                    {institutions?.map((institution, index) => (
                                        <option key={index}
                                            value={institution.value}>
                                            {institution.label}
                                        </option>))}
                                </select>
                                <FiChevronDown className="input-with-icon-tag" />
                            </div>
                        </FormGroupWithIcon>
                    )}
                     


                    <FormGroup>
                        <label>{t('users.createUser.email.label')}</label>
                        <input
                            placeholder={t('users.createUser.email.placeholder')}
                            name='email'
                            type='email'
                            value={input.email}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>
                    <FormGroup>
                        <label>{t('users.createUser.phoneNumber.label')}</label>
                        <input
                            placeholder={t('users.createUser.phoneNumber.placeholder')}
                            name='phoneNumber'
                            type='number'
                            value={input.phoneNumber}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>
                    {/* { userType === UserTypes.ADMIN &&
                        <FlexRow gap="1.5" alignItems="flex-start" justifyContent="flex-start" bottomMargin="2">
                            <AppSpan fontWeight="600" color="#344054">Admin Role</AppSpan>
                            <Switch
                                radius='1.17' bgColor='#E7E7E7' 
                                checkedBgColor='#0D968F' checkedSliderBgColor="#ffffff"
                            >
                                <input 
                                    type="checkbox" 
                                    checked={input.isAdminRole}
                                    onChange={(e) => setInput({...input, isAdminRole: e.target.checked})} 
                                />
                                <div ></div>
                                <span></span>
                            </Switch>
                        </FlexRow> 
                    } */}

                    <FlexRow justifyContent='flex-end'>
                        <Button
                            width='8.1'
                            titleSize='1.4' fontWeight='600'
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            {t('users.createUser.submit')}
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}

type Role = 'SA' | 'QoreDeveloper' | 'QoreUser' | 'Admin' | 'User' | 'InstitutionAdmin'

const roles: Record<UserTypes, { label: string, value: Role, key?: string }[]> = {
    [UserTypes.SUPER_ADMIN]: [
        { label: 'Qore Admin', value: QoreStaffTypes.ADMIN, key: "qoreAdmin" },
        { label: 'QoreDeveloper', value: QoreStaffTypes.DEVELOPER, key: "qoreDeveloper" },
        { label: 'QoreUser', value: QoreStaffTypes.USER, key: "qoreUser" },
        { label: 'Institution Super Admin', value: QoreStaffTypes.INSTITUTION_ADMIN, key: "institutionSuperAdmin" }
    ],
    [UserTypes.ADMIN]: [
        { label: 'Institution Admin', value: UserTypes.ADMIN, key: "institutionAdmin" },
        { label: 'Institution User', value: UserTypes.USER, key: "institutionUser" }
    ],
    [UserTypes.USER]: [{ label: 'Institution User', value: UserTypes.USER, key: "institutionUser" }]
}